<template>
	<div class="row no-gutters">
		<div class="col-lg-4 col-md-4 col-xs-12 mt-2">
			<div class="info">
				<div class="info_icon color-primary-500">
					<i class="fa fa-info" aria-hidden="true"></i>
				</div>

				<div class="pre_show">
					<div class="link_pre">URL для користувачiв:</div>
					<div class="link">
						<a href="https://office.imcagro.com.ua/file-exchange" target="_blank">
							https://office.imcagro.com.ua/file-exchange                            </a>
					</div>
				</div>
			</div>
		</div>

		<div class="col-lg-4 col-md-4 col-xs-12 mt-2">
			<div class="info">
				<div class="info_icon color-primary-500">
					<i class="fa fa-info" aria-hidden="true"></i>
				</div>

				<div class="pre_show">
					<div class="link_pre">Вiльно:</div>
					<div class="link">
						369 GB                        </div>
				</div>
			</div>
		</div>

		<div class="col-lg-4 col-md-4 col-xs-12 mt-2">
			<div class="info">
				<div class="info_icon color-primary-500">
					<i class="fa fa-info" aria-hidden="true"></i>
				</div>

				<div class="pre_show">
					<div class="link_pre">Максимальний розмiр файлу:</div>
					<div class="link">
						600 МB
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "f_info"
}
</script>

<style scoped>

</style>
